//React
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
//API
import { LoginApi } from "../../api";
//LocalStorage
import SecureStorage from "react-secure-storage";
//Material UI
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
//Components
import CircularProgress from "../../components/CircleProgress";
import LoginBox from "../../components/LoginBox/LoginBox";
import ForgotPasswordBox from "../../components/ForgotPassword/ForgotPasswordBox";
import SignUpBox from "../../components/SignUpBox/SignUpBox";

//Assets
import Logo from "../../assets/images/logo.svg";

//CSS
import "./Login.css";

const Login = () => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [capsLock, setCapsLock] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [showLogin, setShowLogin] = useState(true);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);
  const [displayResetPassword, setDisplayResetPassword] = useState(false);

  useEffect(() => {
    const setData = () => {
      SecureStorage.clear();
    };
    setData();
  }, []);

  const handleNavigate = (text) => {
    if (text === "login") {
      setShowLogin(true);
      setShowForgotPassword(false);
      setShowSignUp(false);
    } else if (text === "forgotpassword") {
      setShowLogin(false);
      setShowForgotPassword(true);
      setShowSignUp(false);
    } else if (text === "signup") {
      setShowLogin(false);
      setShowForgotPassword(false);
      setShowSignUp(true);
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordShown(!passwordShown);
  };

  const checkCapsLock = (e) => {
    const capsLockOn = e.getModifierState("CapsLock");
    setCapsLock(capsLockOn);
  };

  const handlePasswordKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (!disabled && !loading) {
        handleLogin();
      }
    } else {
      checkCapsLock(e);
    }
  };

  const handleLogin = async () => {
    if (userId.trim() === "" || password.trim() === "") {
      setDisabled(true);
      alert("아이디와 비밀번호를 입력해주세요.");
      setDisabled(false);
      return;
    }
    setDisabled(true);
    setLoading(true);
    try {
      const response = await LoginApi.login({
        email: userId,
        password: password,
      });
      console.log(response);
      if (response.statusCode === 200) {
        if (response.data.firstLoginYn) {
          SecureStorage.setItem("uid", response.data.uid);
          SecureStorage.setItem("accessToken", response.data.tokenInfo.accessToken);
          SecureStorage.setItem("refreshToken", response.data.tokenInfo.refreshToken);
          setShowLogin(false);
          setShowSignUp(true);
        }
        else {SecureStorage.setItem("uid", response.data.uid);
          SecureStorage.setItem("accessToken", response.data.tokenInfo.accessToken);
          SecureStorage.setItem("refreshToken", response.data.tokenInfo.refreshToken);
          
          const channel = new BroadcastChannel("auth-channel");
          channel.postMessage({
            type: "LOGIN",
            doctorId: response.data.uid,
            email: response.data.email,
            userName: response.data.username,
          });
          channel.close();

          navigate("/main", { replace: true });
        }
      } else {
        setDisabled(false);
        setLoading(false);
        alert('Email 또는 비밀번호가 일치하지 않습니다.');
      }
    }
    catch (error) {
      setDisabled(false);
      setLoading(false);
      alert('Email 또는 비밀번호가 일치하지 않습니다.');
      console.error("Login Error ->", error);
    }
    finally {
      setDisabled(false);
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-title">
        <Logo alt="logo" />
        <div>AI Rotator cuff REGEN</div>
      </div>
      {showLogin && (
        <LoginBox
          userId={userId}
          setUserId={setUserId}
          password={password}
          setPassword={setPassword}
          passwordShown={passwordShown}
          setPasswordShown={setPasswordShown}
          togglePasswordVisibility={togglePasswordVisibility}
          handlePasswordKeyDown={handlePasswordKeyDown}
          capsLock={capsLock}
          checkCapsLock={checkCapsLock}
          disabled={disabled}
          loading={loading}
          setLoading={setLoading}
          handleLogin={handleLogin}
          handleNavigate={handleNavigate}
          setShowForgotPassword={setShowForgotPassword}
        />
      )}
      {showForgotPassword && <ForgotPasswordBox
        userId={userId}
        handleNavigate={handleNavigate}
        loading={loading}
        setLoading={setLoading}
        displayResetPassword={displayResetPassword}
        setDisplayResetPassword={setDisplayResetPassword}
      />}
      {showSignUp && (
        <SignUpBox
          userId={userId}
          handleNavigate={handleNavigate}
          loading={loading}
          setLoading={setLoading}
          displayResetPassword={displayResetPassword}
        />
      )}
    </div>
  );
};

export default Login;
